import { MicrosoftLoginProvider, SocialAuthService } from '@abacritt/angularx-social-login';
import { Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-newregister',
  standalone: false,
  templateUrl: './userRegistration.component.html',
  styleUrl: './userRegistration.component.css'
})
export class UserRegistrationComponent implements OnInit {
  signupForm: UntypedFormGroup;
  emailForm: UntypedFormGroup;
  submitable = false;
  error = '';
  returnUrl: string;
  email: string;
  errorMessage: any;
  step2: boolean = false;
  step1: boolean = !this.step2;
  load: boolean = true;
  processing: boolean = false;
  isLoggedin?: boolean;
  socialUser: any;
  showPassword = false;
  showConfirmPassword = false;

  constructor(private router: Router,private route: ActivatedRoute, private dataservice: CommonService, private formBuilder: UntypedFormBuilder,
    private socialAuthService: SocialAuthService) {
    this.dataservice.getData('/api/checkauth').pipe(
      map((res: Response) => (JSON.stringify(res))))
      .subscribe(
        (response) => {
          this.load = false;
          this.router.navigate(['panel/campaigns']);
        },
        (error) => {
          this.load = true;
          if (error.status === 401) {
              localStorage.removeItem('currentUser');
              localStorage.removeItem('userName');
              localStorage.removeItem('otpemail');
          }
        });
    this.errorMessage = {fname:'',lname:'',email:'',organization:'',password:'',password_confirmation:''};
    // this.emailErrorMessage = {email:''};
    const StrongPasswordRegx: RegExp = /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;
    this.signupForm = this.formBuilder.group({
      fname: ['', [Validators.required]],
      lname: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      organization: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.pattern(StrongPasswordRegx)]],
      password_confirmation: ['', [Validators.required]],
    });
    merge(this.frmCtrl.fname.statusChanges,this.frmCtrl.lname.statusChanges,this.frmCtrl.email.statusChanges,this.frmCtrl.organization.statusChanges,this.frmCtrl.password.statusChanges,this.frmCtrl.password_confirmation.statusChanges, this.frmCtrl.password_confirmation.valueChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateErrorMessage(this.frmCtrl));

    this.emailForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
    merge(this.emailfrmCtrl.email.statusChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateErrorMessage(this.emailfrmCtrl));
  }
  ngOnInit() {
    this.socialAuthService.authState.subscribe((user) => {
      this.socialUser = user;
      this.isLoggedin = user != null;
      if(user){

        this.processing = true;
        const data = {
          email: this.socialUser.email,
          fname: this.socialUser.firstName,
          lname: this.socialUser.lastName,
          name: this.socialUser.name,
          code: this.socialUser.id,
          provider: this.socialUser.provider,
        };
        this.dataservice.sendPostRequest('/api/sso', data).pipe(
          map((res: Response) => (JSON.stringify(res))))
          .subscribe(
            (response) => {
              this.processing = false;
              const result = JSON.parse(response);
              console.log(result);
              localStorage.setItem('currentUser', JSON.stringify(result.access_token));
              localStorage.setItem('userName', result.user.name);
              localStorage.setItem('plan', result.user?.active_subscription?.plan??'');
              this.router.navigate(['panel/campaigns']);
            },
            (error) => {
              this.processing = false;
              if (error.status === 401) {
                this.error = error.error.error_message;
                // this.openSnackBar(error.error.error_message,'Dismiss');
              } else {
                this.error = error.error.error_message;
                // this.openSnackBar(error.error.error_message,'Dismiss');
              }
              console.log(error);
            });
        console.log(this.socialUser,this.isLoggedin,this.socialUser.email);
      }
    });
  }
  signInWithMicrosoft(): void {
    this.socialAuthService.signIn(MicrosoftLoginProvider.PROVIDER_ID);
  }
  // convenience getter for easy access to form fields
  get frmCtrl() {
    return this.signupForm.controls;
  }
  get emailfrmCtrl() {
    return this.emailForm.controls;
  }
  setRegEmail(){
    if (this.emailForm.invalid) {
      return;
    } else {
      this.error = '';
      this.email = this.emailfrmCtrl.email.value;
      this.processing = true;
      const data = {
        email: this.emailfrmCtrl.email.value
      };
      this.dataservice.sendPostRequest('/api/valid-email', data).pipe(
        map((res: Response) => (JSON.stringify(res))))
        .subscribe(
          (response) => {
            this.processing = false;
            const result = JSON.parse(response);
            console.log(result)
            this.frmCtrl.email.setValue(this.emailfrmCtrl.email.value);
            this.step2 = true;
            this.step1 = !this.step2;
          },
          (error) => {
            this.processing = false;
            if(error.status === 400){
              for (let err in error.error) {
                this.error += error.error[err][0]+'<br />';
              }
            } else {
              this.error = error.error.error_message;
              // this.openSnackBar(error.error.error_message,'Dismiss');
            }
          });
    }
  }
  /**
     * Form submit
     */
  onSubmit() {

    // stop here if form is invalid
    if (this.signupForm.invalid) {
      return;
    } else {
      this.error = '';
      this.processing = true;
      const data = {
        fname: this.frmCtrl.fname.value,
        lname: this.frmCtrl.lname.value,
        email: this.frmCtrl.email.value,
        organization: this.frmCtrl.organization.value,
        password: this.frmCtrl.password.value,
        password_confirmation: this.frmCtrl.password_confirmation.value,
        terms: 1,
      };
      this.dataservice.sendPostRequest('/api/register', data).pipe(
        map((res: Response) => (JSON.stringify(res))))
        .subscribe(
          (response) => {
            this.processing = false;
            const result = JSON.parse(response);
            localStorage.setItem('currentUser', JSON.stringify(result.access_token));
            localStorage.setItem('userName', result.user.name);
            this.router.navigate(['panel/campaigns']);
          },
          (error) => {
            this.processing = false;
            if(error.status === 400){
              for (let err in error.error) {
                this.error += error.error[err][0]+'<br />';
              }
            } else {
              this.error = error.error.error_message;
              // this.openSnackBar(error.error.error_message,'Dismiss');
            }
          });
    }
  }
  updateErrorMessage(frm) {
    this.submitable = true;
    if (frm.fname && frm.fname.hasError('required')) {
      this.errorMessage.fname = 'First name is required';
      this.submitable = false;
    }
    if (frm.lname && frm.lname.hasError('required')) {
      this.errorMessage.lname = 'Last name is required';
      this.submitable = false;
    }
    if (frm.email && frm.email.hasError('required')) {
      this.errorMessage.email = 'Email is required';
      this.submitable = false;
    } else if (frm.email && frm.email.hasError('email')) {
      this.errorMessage.email = 'Not a valid email';
      this.submitable = false;
    }
    if (frm.organization && frm.organization.hasError('required')) {
      this.errorMessage.organization = 'Company/Organization name is required';
      this.submitable = false;
    }

    if (frm.password && frm.password.hasError('required')) {
      this.errorMessage.password = 'Password is required';
      this.submitable = false;
    }else if (frm.password && frm.password.hasError('pattern')) {
      this.errorMessage.password = 'Password should contain at leat 8 characters, 1 capital letter, 1 number and 1 special character';
      this.submitable = false;
    }
    
    if (frm.password_confirmation && frm.password_confirmation.hasError('required')) {
      this.errorMessage.password_confirmation = 'Confirm password';
      this.submitable = false;
    }else if (frm.password_confirmation && frm.password_confirmation.hasError('not_match')) {
      this.errorMessage.password_confirmation = 'Password do not match';
      this.submitable = false;
    }else if(frm.password && frm.password.value !== frm.password_confirmation.value){
      frm.password_confirmation.markAsDirty();
      frm.password_confirmation.markAsTouched();
      frm.password_confirmation.setErrors({'not_match':true});
    }
  }
}
